import { apiFetch } from './client';
import type { VoteAggregate, VoteWithHand } from '../types/mjai';

export interface VotePayload {
  chosen_tile?: string;
  riichi?: boolean;
  naki_action?: string;
  comment?: string;
}

export async function getVotes(hand_id: string): Promise<VoteAggregate> {
  return apiFetch<VoteAggregate>(`/votes/${hand_id}`);
}

export async function createVote(hand_id: string, payload: VotePayload): Promise<void> {
  await apiFetch(`/votes/${hand_id}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateVote(hand_id: string, payload: Partial<VotePayload>): Promise<void> {
  await apiFetch(`/votes/${hand_id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export async function deleteVote(hand_id: string): Promise<void> {
  await apiFetch(`/votes/${hand_id}`, { method: 'DELETE' });
}

export async function getMyVotes(params?: {
  page?: number;
  page_size?: number;
}): Promise<VoteWithHand[]> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.page_size) query.set('page_size', String(params.page_size));
  return apiFetch<VoteWithHand[]>(`/votes?${query}`);
}
